import { Component, inject, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ALLOWED_EXTENSIONS = new Set(['pdf', 'jpg', 'jpeg', 'png']);

// Documenti del nuovo cliente: il riquadro per allegarli, anche trascinandoli, e sotto l'elenco
@Component({
  selector: 'ord-new-customer-upload',
  imports: [MatButtonModule],
  templateUrl: './new-customer-upload.html',
  styleUrl: './new-customer-upload.scss',
})
export class NewCustomerUpload {
  private readonly snackBar = inject(MatSnackBar);

  readonly files = input<File[]>([]);
  readonly multiple = input(false);
  readonly filesChange = output<File[]>();

  readonly dragging = signal(false);

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selected = Array.from(input.files ?? []);
    input.value = '';
    this.add(selected);
  }

  dragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragging.set(true);
  }

  drop(event: DragEvent): void {
    event.preventDefault();
    this.dragging.set(false);
    this.add(Array.from(event.dataTransfer?.files ?? []));
  }

  remove(index: number): void {
    this.filesChange.emit(this.files().filter((_, fileIndex) => fileIndex !== index));
  }

  private add(selected: File[]): void {
    if (selected.length === 0) {
      return;
    }

    // Solo PDF, JPG o PNG fino a 10MB
    const valid = selected.filter(file => this.isValidFile(file));
    if (valid.length < selected.length) {
      this.snackBar.open('Sono ammessi solo file PDF, JPG o PNG fino a 10MB', 'Chiudi', { duration: 5000 });
    }

    this.filesChange.emit(this.multiple() ? [...this.files(), ...valid] : valid.slice(0, 1));
  }

  private isValidFile(file: File): boolean {
    const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
    return ALLOWED_EXTENSIONS.has(extension) && file.size <= MAX_FILE_SIZE;
  }
}
